export default "__VITE_ASSET__gRihefIK__"